interface AppConfig {
    signInUrl: string;
    signOutUrl: string;
    cognitoDomain: string;
    googleClientId?: string;
    provider: string;
}

export const getAppConfig = function (): AppConfig {
    let hostNames = window.location.hostname.split(".");

    if (hostNames.length == 1) {
        //localhost
        return {
            cognitoDomain: "stagingauth.roomsync.com",
            signInUrl: "http://localhost:3000/",
            signOutUrl: "http://localhost:3000/",
            provider: "Google"
        };
    }

    switch (hostNames[0]) {
        case "stagingadmin":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingadmin.roomsync.com/",
                signOutUrl: "https://stagingadmin.roomsync.com/",
                provider: "Google"
            };
        case "admin":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://admin.roomsync.com/",
                signOutUrl: "https://admin.roomsync.com/",
                provider: "Google"
            };
        case "stagingacc":
            return {
                cognitoDomain: "roomsync-staging-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://stagingacc.roomsync.com/",
                signOutUrl: "https://stagingacc.roomsync.com/",
                provider: "ACC"
            };
        case "acc":
            return {
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://acc.roomsync.com/",
                signOutUrl: "https://acc.roomsync.com/",
                provider: "ACC"
            };
        case "staginglandmark":
            return {
                cognitoDomain: "roomsync-staging-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://staginglandmark.roomsync.com/",
                signOutUrl: "https://staginglandmark.roomsync.com/",
                provider: "Landmark"
            };
        case "landmark":
            return {
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://landmark.roomsync.com/",
                signOutUrl: "https://landmark.roomsync.com/",
                provider: "Landmark"
            };
        case "stagingtrinity":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingtrinity.roomsync.com/",
                signOutUrl: "https://stagingtrinity.roomsync.com/",
                provider: "Trinity"
            };
        case "trinity":
            return {
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://trinity.roomsync.com/",
                signOutUrl: "https://trinity.roomsync.com/",
                provider: "Trinity"
            };
        case "stagingcardinal":
            return {
                cognitoDomain: "roomsync-staging-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://stagingcardinal.roomsync.com/",
                signOutUrl: "https://stagingcardinal.roomsync.com/",
                provider: "Cardinal"
            };
        case "cardinal":
            return {
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://cardinal.roomsync.com/",
                signOutUrl: "https://cardinal.roomsync.com/",
                provider: "Cardinal"
            };
        case "stagingcampusadv":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingcampusadv.roomsync.com/",
                signOutUrl: "https://stagingcampusadv.roomsync.com/",
                provider: "Campusadv"
            };
        case "campusadv":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingcampusadv.roomsync.com/",
                signOutUrl: "https://stagingcampusadv.roomsync.com/",
                provider: "Campusadv"
            };
        case "stagingtdc":
            return {
                cognitoDomain: "roomsync-staging-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://stagingtdc.roomsync.com/",
                signOutUrl: "https://stagingtdc.roomsync.com/",
                provider: "TDC"
            };
        case "tdc":
            return {
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://tdc.roomsync.com/",
                signOutUrl: "https://tdc.roomsync.com/",
                provider: "TDC"
            };
        case "staginggmh":
            return {
                cognitoDomain: "roomsync-staging-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://staginggmh.roomsync.com/",
                signOutUrl: "https://staginggmh.roomsync.com/",
                provider: "GMH"
            };
        case "gmh":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://gmh.roomsync.com/",
                signOutUrl: "https://gmh.roomsync.com/",
                provider: "GMH"
            };
        case "staginghorizon":
            return {
                cognitoDomain: "staging.roomsync.com",
                signInUrl: "https://staginghorizon.roomsync.com/",
                signOutUrl: "https://staginghorizon.roomsync.com/",
                provider: "Horizon"
            };
        case "horizon":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://horizon.roomsync.com/",
                signOutUrl: "https://horizon.roomsync.com/",
                provider: "Horizon"
            };
        case "stagingbalfour":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingbalfour.roomsync.com/",
                signOutUrl: "https://stagingbalfour.roomsync.com/",
                provider: "Balfour"
            };
        case "balfour":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://balfour.roomsync.com/",
                signOutUrl: "https://balfour.roomsync.com/",
                provider: "Balfour"
            };
        case "solomon":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://solomon.roomsync.com/",
                signOutUrl: "https://solomon.roomsync.com/",
                provider: "Solomon"
            };
        case "peakmade":
            return {
                // cognitoDomain: "productionauth.roomsync.com",
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://peakmade.roomsync.com/",
                signOutUrl: "https://peakmade.roomsync.com/",
                provider: "PeakMade"
            };
        case "asset":
            return {
                // cognitoDomain: "productionauth.roomsync.com",
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://asset.roomsync.com/",
                signOutUrl: "https://asset.roomsync.com/",
                provider: "Asset"
            };
        case "greystar":
            return {
                // cognitoDomain: "productionauth.roomsync.com",
                cognitoDomain: "roomsync-production-admin.auth.us-east-1.amazoncognito.com",
                signInUrl: "https://greystar.roomsync.com/",
                signOutUrl: "https://greystar.roomsync.com/",
                provider: "Greystar"
            };
        case "staginggreystar":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://staginggreystar.roomsync.com/",
                signOutUrl: "https://staginggreystar.roomsync.com/",
                provider: "Greystar"
            };
        case "stagingndus":
            return {
                cognitoDomain: "stagingauth.roomsync.com",
                signInUrl: "https://stagingndus.roomsync.com/",
                signOutUrl: "https://stagingndus.roomsync.com/",
                provider: "NDUS"
            };
        case "bama":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://bama.roomsync.com/",
                signOutUrl: "https://bama.roomsync.com/",
                provider: "Bama"
            };
        case "uwec":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://uwec.roomsync.com/",
                signOutUrl: "https://uwec.roomsync.com/",
                provider: "UWEC"
            };
        case "k-state":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://k-state.roomsync.com/",
                signOutUrl: "https://k-state.roomsync.com/",
                provider: "K-STATE"
            };
        case "uwstout":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://uwstout.roomsync.com/",
                signOutUrl: "https://uwstout.roomsync.com/",
                provider: "UWSTOUT"
            };
        case "jonesstreet":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://jonesstreet.roomsync.com/",
                signOutUrl: "https://jonesstreet.roomsync.com/",
                provider: "jonesstreet"
            };
        case "ndus":
            return {
                cognitoDomain: "productionauth.roomsync.com",
                signInUrl: "https://ndus.roomsync.com/",
                signOutUrl: "https://ndus.roomsync.com/",
                provider: "NDUS"
            };
    }

    return {signInUrl: "", signOutUrl: "", cognitoDomain: "", provider: "BAD!!!"};
};